export default ({ request }) => ({
  sampleInfoListApi(data = {}) {
    return request({
      url: '/master/sample/info/list',
      method: 'post',
      data
    })
  },
  sampleInfoDetailApi(data = {}) {
    return request({
      url: '/master/sample/info/detail',
      method: 'post',
      data
    })
  },
  sampleInfoSaveApi(data = {}) {
    return request({
      url: '/master/sample/info/save',
      method: 'post',
      data
    })
  },
  sampleInfoDelApi(data = {}) {
    return request({
      url: '/master/sample/info/del',
      method: 'post',
      data
    })
  },
  sampleInfoCopyApi(data = {}) {
    return request({
      url: '/master/sample/info/copy',
      method: 'post',
      data
    })
  },
  sampleInfoAuditApi(data = {}) {
    return request({
      url: '/master/sample/info/audit',
      method: 'post',
      data
    })
  },
  setsampleInfoDefaultImageApi(data = {}) {
    return request({
      url: '/master/sample/info/image/defaultImage',
      method: 'post',
      data
    })
  },
  sampleInfoImageListApi(data = {}) {
    return request({
      url: '/master/sample/info/image/list',
      method: 'post',
      data
    })
  },
  sampleInfoImageDelApi(data = {}) {
    return request({
      url: '/master/sample/info/image/del',
      method: 'post',
      data
    })
  },
  sampleInfoImageBatchUploadApi(data = {}) {
    return request({
      url: '/master/sample/info/image/batch/upload',
      method: 'post',
      data
    })
  },
  sampleInfoMaterialListApi(data = {}) {
    return request({
      url: '/master/sample/info/material/list',
      method: 'post',
      data
    })
  },
  sampleInfoMaterialDetailApi(data = {}) {
    return request({
      url: '/master/sample/info/material/detail',
      method: 'post',
      data
    })
  },
  sampleInfoMaterialSaveApi(data = {}) {
    return request({
      url: '/master/sample/info/material/save',
      method: 'post',
      data
    })
  },
  sampleInfoMaterialDelApi(data = {}) {
    return request({
      url: '/master/sample/info/material/del',
      method: 'post',
      data
    })
  },
  sampleInfoMaterialUpdateSortApi(data = {}) {
    return request({
      url: '/master/sample/info/material/updateSort',
      method: 'post',
      data
    })
  },
  sampleInfoSelectQtyUnitApi(data = {}) {
    return request({
      url: '/master/common/dict/biz',
      method: 'post',
      data
    })
  },
  sampleInfoLinkDataListApi(data = {}) {
    return request({
      url: '/master/sample/info/linkData/list',
      method: 'post',
      data
    })
  },
  masterFabricListApi(data = {}) {
    return request({
      url: '/master/fabric/list',
      method: 'post',
      data
    })
  },
  masterFabricAttributesSelectApi(data = {}) {
    return request({
      url: '/master/fabric/attributes/attributesSelect',
      method: 'post',
      data
    })
  },
  sampleInfoAuditListApi(data = {}) {
    return request({
      url: '/master/sample/info/auditList',
      method: 'post',
      data
    })
  }
})
